// 邮箱验证弹窗
import { Button, Modal, message } from 'antd'
// import Countdown from "antd/lib/statistic/Countdown";
import { inject, observer } from 'mobx-react'
import React, { useState } from 'react'

function GetFreeNumberModal(props) {
  const { userStore } = props
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(true)
  const { tryGetFreeNumber, freeNumber, isUserFreeType, userCanGetFreeNumber, isUserEmailVerified } = userStore

  const visible =
    showModal &&
    isUserFreeType && // 免费用户
    isUserEmailVerified && //  已验证邮箱
    userCanGetFreeNumber // 可以获取免费号码

  const showResult = freeNumber

  const onTryItNowClick = () => {
    setShowModal(false)
    userStore.requestUserInfo()
    userStore.requestUserPhones()
  }
  const getFreeNumberClick = () => {
    setLoading(true)
    userStore
      .requestFreeNumber()
      .then((res) => {
        if (!res) {
          message.error('Failed to get the fax number. Please retry.')
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <Modal visible={visible} footer={null} closable={false}>
      <div className="text-center">
        <div className="wp">
          {showResult ? (
            <div>
              <h2 className="text-blue tip">Here's your new fax number:</h2>
              <div className="num font-bold" style={{ fontSize: '24px' }}>
                {freeNumber}
              </div>
              <br />
              <p className="info">Now we are good to go!</p>
              <br />
              <Button type="primary" size="large" onClick={onTryItNowClick}>
                Try It Now
              </Button>
            </div>
          ) : (
            <div>
              <h2 className="text-blue tip">Welcome to CocoFax.</h2>
              <br />
              <p className="info">
                You don't currently have a fax number. You can reserve a fax number to send fax online now.
              </p>
              <br />
              <Button loading={loading} type="primary" size="large" danger onClick={getFreeNumberClick}>
                Reserve a Fax Number
              </Button>
            </div>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default inject('userStore')(observer(GetFreeNumberModal))
